import { cloneDeep } from "lodash";

const initialState = {
  chatbots: [],
  total_pages: 0,
  savingChatbot: false,
  savedChatbotStatus: false,
  chatbotSaved: null,
  loading: false
};

const chatbotsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CHATBOTS_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'GET_CHATBOTS_REQUEST_END':
      return {
        ...state,
        loading: false
      };
    case 'GET_CHATBOTS':
      return {
        ...state,
        chatbots: action.data.chatbots,
        total_pages: action.data.total_pages,
        pagination: action.data.pagination
      };
    case 'START_SAVING_CHATBOT_REQUEST':
      return {
        ...state,
        savingChatbot: true
      };
    case 'END_SAVING_CHATBOT_REQUEST':
      return {
        ...state,
        savingChatbot: false
      };
    case 'CREATE_CHATBOT': {
      let updatedData = cloneDeep(state.chatbots);
      updatedData.unshift(action.data?.chatbot);

      return {
        ...state,
        chatbots: updatedData
      };
    }
    case 'DELETE_CHATBOT': {
      return {
        ...state,
        chatbots: state.chatbots.filter(item => item.web_id !== action.web_id)
      };
    }
    case 'UPDATE_CHATBOT': {
      return {
        ...state,
        chatbots: state.chatbots.map(item => (item.id === action.data.chatbot.id ? item = action.data.chatbot: item))
      };
    }
    case 'SET_SAVED_CHATBOT_STATUS':
      return {
        ...state,
        savedChatbotStatus: action.status
      };
    case 'SET_CHATBOT_SAVED':
      return {
        ...state,
        chatbotSaved: action.data.chatbot
      };
    default:
      return state;
  }
};

export default chatbotsReducer;
